<template>
  <div class="fullpage">
    <template v-for="(city, index) in cities" :key="index">
      <div
        @click="chooseCity(city.name)"
        class="city-item"
        :class="city.name == city_name ? ' selected' : ''"
      >
        {{ city.name }}
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: ["city_name"],
  data: () => {
    return {
      cities: [
        { name: "Landelijk bestuur" },
        { name: "Amsterdam" },
        { name: "Delft" },
        { name: "Groningen" },
        { name: "Leiden" },
        { name: "Maastricht" },
        { name: "Rotterdam" },
        { name: "Utrecht" },
      ],
    }
  },
  methods: {
    chooseCity(name) {
      this.$emit("chooseCity", name)
    },
  },
}
</script>

<style scoped>
.fullpage {
  height: 100%;
  width: 100%;
}

.city-item {
  padding: 3% 5%;
  color: #3898ec;
  border-color: aliceblue;
  border-width: 1px;
  border-style: solid;
  border-radius: 28px;
  margin-bottom: 2%;
  transition: 500ms;
}

.city-item:hover {
  background-color: #3898ec;
  color: white;
  cursor: pointer;
}

.city-item.selected {
  background-color: #3898ec;
  color: white;
  cursor: pointer;
}
</style>
